import { environment } from "src/environments/environment";

export class Constants {
	public navLinkItems = {

		home: { home: { displayName: 'Home', url: 'home' } },
		user: {
			person: { displayName: 'MAX JONES', icon: 'person' },
			id: { displayName: '10034' },
			profile: { displayName: 'ADMIN' },
			help: { displayName: 'HELP', icon: 'help' },
			settings: { displayName: 'SETTINGS', icon: 'settings' },
			logout: { displayName: 'LOGOUT', icon: 'logout' }
		},
		planning: {
			alarms: { displayName: 'ALARMS', url: environment.ALARMS },
			allo: { displayName: 'ALLO', url: environment.ALLO },
			companyInfoChange: { displayName: 'company Info Change', url: 'mshell/maintenance/company-info-change' },
			costPlanning: { displayName: 'COST PLANNING', url: environment.COST_PLANNING },
			eboi: { displayName: 'EBOI', url: environment.EBOI },
			exports: { displayName: 'EXPORTS', url: environment.EXPORT },
			forecastAdmin: { displayName: 'Forecast Admin Dashboard (Import/Export dashboard)', url: environment.FORECAST_ADMIN_DASHBOARD },
			fto: { displayName: 'FTOs', url: 'opershell/operations/fto' },
			group1: { displayName: 'GROUP I', url: environment.GROUPI },
			dashboard: { displayName: 'Import/Export', url: 'opershell/operations/dashboard' },
			masterDock: { displayName: 'Master Dock', url: 'mshell/maintenance/master-dock' },
			regionTargets: { displayName: 'Region Targets', url: 'opershell/operations/region-targets' },
			scnc: { displayName: 'SCNC', url: 'opershell/operations/scnc' },
			taskManager: { displayName: 'TASK MANAGER', url: environment.TASK_MANAGER },
			tlmsSend: { displayName: 'TLMS Send', url: environment.TLMS_SEND },
			delayedDispatch: { displayName: 'Delayed Dispatch', url: environment.DD },
		},
		operations: {
			aet: { displayName: 'AET', url: environment.AET },
			companyInfo: { displayName: 'company Info', url: 'mshell/maintenance/company-info' },
			lpBilling: { displayName: 'LP Billing', url: 'bshell', fga: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary'] },
			trailerLoadDiagrams: { displayName: 'Trailer Load Diagrams', url: environment.TLD },
			uxmxroutes: { displayName: 'US MX Routes', url: 'opershell/operations/uxmxroutes' },
			wtResolution: { displayName: 'WT Resolution ', url: 'mshell/maintenance/window-times', fga: ['Window Times', 'TLMS Send'] },
			returnsReload: { displayName: 'Returns Reload', url: 'mshell/maintenance/returns-reload' },
		},
		reporting: {
			scheduleDashboard: { displayName: 'Schedule Dashboard', url: environment.SCHEDULE_DASHBOARD },
			reports: { displayName: 'Reports', url: environment.REPORTS },
		},
		maintenance: {
			notificationGroup: { displayName: 'Notification Group', url: 'admin/notification-group' },
			permissionManagement: { displayName: 'Permission Management', url: 'mshell/apm/permission-management/user-management' },
		}
	}
	public liosMenuItems = [
		{ displayName: 'COMPANY INFORMATION' },
		{ displayName: 'MASTER DATA' },
		{ displayName: 'IMPORT/EXPORT' },
		{ displayName: 'WINDOW TIMES' },
		{ displayName: 'REPORTING' },
		{ displayName: 'ADMIN' },
		{ displayName: 'BILLING' },
		{ displayName: 'DELAYED DISPATCH' },
		{ displayName: 'AET' },
		{ displayName: 'TSCS' },
		{ displayName: 'TPT' },
		{ displayName: 'PLANNING' },
		{ displayName: 'EXPORTS PARTS' }
	];
	public LIOSMainPortalURL = environment.LOGOUT_REDIRECT_URL;
	public LIOS_UAC_Admin = "Admin";
	public LIOS_UAC_NAMCPlanner60EXP = "NAMC Planner/60EXP";
	public notificationMessageTimeShort = 5000;
	public notificationMessageTimeLong = 10000;
	public LoaderComponent = "loader-component";
	public LoaderInitializer = "loader-initializer";
	public FileValidation = "Validation failed, Please find error details below";
	public APIErrorMessage = "Something went wrong, Please Contact System Administrator";
	public APIDataSaved = "Data saved successfully";
	public APIDataUpdated = "Data updated successfully";
	public APIDataDeleted = "Data deleted successfully";
	public FileUploaded = "File uploaded successfully";
	public formInputError = "Please fill in the required fields!";
	public failedFileUpload ="File Upload Failed!"

	constructor() {
		this.LIOSMainPortalURL = environment.LIOS_HOME_URL;
	}
}

export const generateRandomString = (length = 6): string => {
	const chars =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	for (let i = 0; i < length; i++) {
		result += chars.charAt(Math.floor(Math.random() * chars.length));
	}
	return result;
};

export const FILE_UPLOAD_TIMEOUT = 300000;
